<template>
  <div class="index-box">
    <GlobalSearch :type="'cos_fbu'"></GlobalSearch>

    <div class="top-tab-box">
      <div class="top-tab new-clue" @click="handleRouterGo('/fbu/salesClue/add')">
        <img src="@/assets/index/new-clue.svg" alt="" />
        <div class="top-tab-msg">
          <p>新建线索</p>
          <span>LEADS</span>
        </div>
      </div>
      <div class="top-tab new-business" @click="handleRouterGo('/fbu/business/add')">
        <img src="@/assets/index/new-business.svg" alt="" />
        <div class="top-tab-msg">
          <p>新建商机</p>
          <span>OPPORTUNITIES</span>
        </div>
      </div>
      <div class="top-tab new-visitor" @click="handleRouterGo('/fbu/visitorProgram/add')">
        <img src="@/assets/index/new-visitor.svg" alt="" />
        <div class="top-tab-msg">
          <p>新建访客计划</p>
          <span>VISITORS PROGRAM</span>
        </div>
      </div>
      <div class="top-tab new-follow" @click="handleRouterGo('/fbu/followUpRecord/add')">
        <img src="@/assets/index/new-follow.svg" alt="" />
        <div class="top-tab-msg">
          <p>写新跟进</p>
          <span>FOLLOW-UP</span>
        </div>
      </div>
    </div>
    <div class="key-data-box">
      <div class="top-label-from-box">
        <p>关键数据指标</p>
        <div class="from-box">
          <cos-range-picker
            v-model:startTime="formState.keyData.startTime"
            v-model:endTime="formState.keyData.endTime"
          />
        </div>
      </div>
      <div class="key-data">
        <div class="data-box">
          <img src="@/assets/index/key-new-clue.svg" alt="" />
          <div class="data-msg">
            <p>新增线索数</p>
            <span style="color: #877ced">{{ keyBackData.clueCount || 0 }}<span>个</span></span>
          </div>
        </div>
        <div class="data-box">
          <img src="@/assets/index/key-new-business.svg" alt="" />
          <div class="data-msg">
            <p>新增商机数</p>
            <span style="color: #36c8e1">{{ keyBackData.chanceCount || 0 }}<span>个</span></span>
          </div>
        </div>
        <div class="data-box">
          <img src="@/assets/index/key-new-visitor.svg" alt="" />
          <div class="data-msg">
            <p>新增访客计划数</p>
            <span style="color: #4ec690">{{ keyBackData.visitCount || 0 }}<span>个</span></span>
          </div>
        </div>
        <div class="data-box">
          <img src="@/assets/index/key-new-follow.svg" alt="" />
          <div class="data-msg">
            <p>新增跟进记录数</p>
            <span style="color: #ffb648">{{ keyBackData.followCount || 0 }}<span>个</span></span>
          </div>
        </div>
        <div class="data-box">
          <img src="@/assets/index/key-new-money.svg" alt="" />
          <div class="data-msg">
            <p>新增商机金额数</p>
            <span style="color: #3f97ff">{{ keyBackData.planSaleAmount || 0 }}<span>万元</span></span>
          </div>
        </div>
      </div>
    </div>
    <a-row :gutter="16">
      <a-col :span="12">
        <!-- 商机金额 -->
        <HomeBusinessAmountBarChart appId="cos_fbu" />
      </a-col>
      <a-col :span="12">
        <div class="out-box">
          <Calendar :appId="'fbu'"></Calendar>
        </div>
      </a-col>
    </a-row>
    <a-row :gutter="16">
      <a-col :span="12">
        <!-- 按负责人统计 -->
        <HomeLeadOrUserBarChar appId="cos_fbu" type="user" />
      </a-col>
      <a-col :span="12">
        <!-- 商机分析 -->
        <HomeOpportunityFunnel appId="cos_fbu" />
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="24">
        <!-- 线索来源统计 -->
        <HomeLeadOrUserBarChar appId="cos_fbu" type="lead" />
      </a-col>
    </a-row>
    <!-- <a-row>
      <a-col :span="24">
        <div class="out-box-task">
          <div class="top-label-from-box">
            <p>周期跟进任务</p>
            <div class="from-box">
              <a-select
                ref="select"
                class="input"
                v-model:value="formState.cycleFollowTask.depCode"
                style="width: 220px"
              >
                <a-select-option value="all">全部数据</a-select-option>
                <a-select-option value="my">我的数据</a-select-option>
              </a-select>
            </div>
          </div>
          <periodic-follow-task :option="followTask"></periodic-follow-task>
        </div>
      </a-col>
    </a-row> -->
    <a-row>
      <a-col :span="24">
        <div class="out-box-task">
          <div class="top-label-from-box">
            <p>待转化任务</p>
            <div class="from-box">
              <a-date-picker
                class="input"
                v-model:value="formState.toConvertTask.month"
                placeholder="请选择日期"
                picker="month"
                :allowClear="false"
              />
              <a-select ref="select" class="input" v-model:value="formState.toConvertTask.depCode" style="width: 220px">
                <a-select-option value="all">全部数据</a-select-option>
                <a-select-option value="my">我的数据</a-select-option>
              </a-select>
            </div>
          </div>
          <periodic-follow-task :option="readyChangeTask"></periodic-follow-task>
        </div>
      </a-col>
      <!-- <a-col :span="12">
        <div class="out-box-task">
          <div class="top-label-from-box">
            <p>其他任务</p>
            <div class="from-box">
              <cos-range-picker
                v-model:startTime="formState.otherTask.startTime"
                v-model:endTime="formState.otherTask.endTime"
                :allowClear="false"
              />
              <a-select ref="select" class="input" v-model:value="formState.otherTask.depCode" style="width: 220px">
                <a-select-option value="all">全部数据</a-select-option>
                <a-select-option value="my">我的数据</a-select-option>
              </a-select>
            </div>
          </div>
          <periodic-follow-task :option="otherTask"></periodic-follow-task>
        </div>
      </a-col> -->
    </a-row>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive } from 'vue'
import HomeBusinessAmountBarChart from '@/components/HomeBusinessAmountBarChart/index.vue'
import HomeLeadOrUserBarChar from '@/components/HomeLeadOrUserBarChar/index.vue'
import HomeOpportunityFunnel from '@/components/HomeOpportunityFunnel/index.vue'
import Calendar from '@/components/Calendar/index.vue'
import PeriodicFollowTask from './components/PeriodicFollowTask.vue'
import taskSetting from './hooks/taskData'
import barEChartData from './hooks/barChartData'
import keyBackDataMethod from './hooks/keyDataBack'
import { getCurrentMonthDateRange } from '@/utils/timeFormat'
import type { IndexUserParams, ClueParams } from '@/types/index'
import dayjs from 'dayjs'
import GlobalSearch from '@/components/GlobalSearch/index.vue'
import { useRouter, useRoute } from 'vue-router'
interface ChanceAnalysis {
  startTime?: any
  endTime?: any
  depCode?: string
  month?: any
}
interface FormState {
  allSearch: string
  keyData: ChanceAnalysis
  chanceAnalysis: ChanceAnalysis
  chanceSales: ChanceAnalysis
  userList: IndexUserParams
  clueData: ClueParams
  followData: ChanceAnalysis
  cycleFollowTask: ChanceAnalysis
  otherTask: ChanceAnalysis
  toConvertTask: ChanceAnalysis
}
export default defineComponent({
  name: 'DcCosFbuIndex',
  components: {
    HomeBusinessAmountBarChart,
    HomeLeadOrUserBarChar,
    HomeOpportunityFunnel,
    Calendar,
    PeriodicFollowTask,
    GlobalSearch
  },
  setup() {
    const { firstDayOfMonth, currentDayOfMonth, lastDayOfMonth } = getCurrentMonthDateRange('currentTime')
    const formState = reactive<FormState>({
      allSearch: '',
      keyData: {
        startTime: firstDayOfMonth,
        endTime: currentDayOfMonth,
        depCode: 'all'
      },
      chanceAnalysis: {
        startTime: firstDayOfMonth,
        endTime: currentDayOfMonth,
        depCode: 'all'
      },
      chanceSales: {
        startTime: firstDayOfMonth,
        endTime: lastDayOfMonth,
        depCode: 'all'
      },
      userList: {
        startTime: firstDayOfMonth,
        endTime: currentDayOfMonth,
        depCode: 'all'
      },
      clueData: {
        startTime: firstDayOfMonth,
        endTime: currentDayOfMonth,
        depCode: 'all'
      },
      followData: {
        startTime: firstDayOfMonth,
        endTime: currentDayOfMonth,
        depCode: 'all'
      },
      cycleFollowTask: {
        depCode: 'all'
      },
      otherTask: {
        startTime: firstDayOfMonth,
        endTime: currentDayOfMonth,
        depCode: 'all'
      },
      toConvertTask: {
        month: dayjs(),
        depCode: 'all'
      }
    })
    const { keyBackData } = keyBackDataMethod(formState.keyData)
    const { principalStatistics, businessAmount, cueSourceStatistics } = barEChartData(formState)
    // const { followTask, readyChangeTask, otherTask } = taskSetting(formState)
    const { readyChangeTask } = taskSetting(formState)

    const router = useRouter()
    const route = useRoute()

    const handleRouterGo = (path: string) => {
      router.push({
        path: path,
        query: {
          returnPath: route.fullPath
        }
      })
    }
    return {
      formState,
      // followTask,
      readyChangeTask,
      // otherTask,
      principalStatistics,
      businessAmount,
      cueSourceStatistics,
      keyBackData,
      handleRouterGo
    }
  }
})
</script>
<style lang="scss" scoped>
.index-box {
  background: rgb(249, 249, 255);
  padding: 20px 30px;
}

.out-box-task {
  background: #ffffff;
  border-radius: 4px;
  margin-bottom: 16px;
}
.out-box {
  background: #ffffff;
  border-radius: 4px;
  height: 437px;
  margin-bottom: 16px;
}
.top-tab-box {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  .top-tab {
    cursor: pointer;
    width: 24.5%;
    height: 94px;
    display: flex;
    align-items: center;
    padding-left: 20px;
    border-left: 4px solid #000;
    img {
      width: 46px;
      height: 46px;
    }
    .top-tab-msg {
      margin-left: 16px;
      p {
        font-weight: 500;
        font-size: 16px;
        color: #333333;
      }
      span {
        font-weight: 400;
        font-size: 14px;
      }
    }
  }
  .new-clue {
    background: #efecfd;
    border-left: 4px solid #877ced;
    border-radius: 2px;
    .top-tab-msg {
      span {
        color: #877ced;
      }
    }
  }
  .new-business {
    background: #e4f8fb;
    border-left: 4px solid #36c8e1;
    border-radius: 2px;
    .top-tab-msg {
      span {
        color: #36c8e1;
      }
    }
  }
  .new-visitor {
    background: #e5f7ed;
    border-left: 4px solid #4ec690;
    border-radius: 2px;
    .top-tab-msg {
      span {
        color: #4ec690;
      }
    }
  }
  .new-follow {
    background: #fdf1e2;
    border-left: 4px solid #ffb648;
    border-radius: 2px;
    .top-tab-msg {
      span {
        color: #ffb648;
      }
    }
  }
}
.key-data-box {
  width: 100%;
  background: #ffffff;
  margin-bottom: 16px;
  .key-data {
    width: 100%;
    display: flex;
    .data-box {
      width: 20%;
      height: 98px;
      display: flex;
      align-items: center;
      img {
        width: 46px;
        height: 46px;
        display: block;
        margin: 0 16px 0 24px;
      }
      .data-msg {
        p {
          font-weight: 400;
          font-size: 14px;
        }
        span {
          font-weight: 700;
          font-size: 20px;
          span {
            font-size: 10px;
          }
        }
      }
    }
  }
}
.top-label-from-box {
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
  padding: 0 24px;
  box-sizing: border-box;
  justify-content: space-between;
  .input {
    width: 222px;
    margin-left: 10px;
  }
  p {
    font-weight: 500;
    font-size: 16px;
  }
  .from-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
